import { styled } from '@glitz/react';

export const overflowEllipsisDecorator = styled({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
